/**
 * Labstep
 *
 * @module components/Chemical/Form/ShowEdit/Equivalence
 * @desc ShowEditEquivalence for Chemical
 */

import { fieldEquivalence } from 'labstep-web/components/Chemical/Form/fields';
import { FormShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import { Chemical } from 'labstep-web/models/chemical.model';
import type React from 'react';
import type { ChemicalFormShowEditEquivalenceProps } from './types';

export const ChemicalFormShowEditEquivalence: React.FC<
  ChemicalFormShowEditEquivalenceProps
> = ({ chemical }) => (
  <FormShowEditText
    entityName={Chemical.entityName}
    entity={chemical}
    field={fieldEquivalence}
    placeholder="Enter"
  >
    {chemical.equivalence}
  </FormShowEditText>
);
